import React from "react";

export const ToggleLeftIcon = ({ width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width }}
  >
    <circle cx="9" cy="12" r="3" />
    <rect width="20" height="14" x="2" y="5" rx="7" />
  </svg>
);
